import { Link } from 'react-router-dom';

/**
 * The app's generic "this doesn't exist" screen (Phase 7 Task 11) — first consumer is
 * `StaffGate.tsx` (a non-staff account hitting `/admin/**` renders this, never any hint that an
 * admin console exists at all — no admin-surface oracle, mirroring the server's own opaque 404).
 * Deliberately generic copy: this is NOT the same thing as any one screen's own domain-specific
 * "not found" state (e.g. ProfileScreen's "Profile not found.", LandScreen's unknown-event state)
 * — those stay as they are; this is only for "you hit a route/gate with nothing behind it."
 */
export function NotFoundScreen() {
  return (
    <main className="screen-form">
      <div className="retry-card not-found-card">
        <h1>This page doesn&rsquo;t exist.</h1>
        <p>The link may be old or mistyped.</p>
        <Link to="/habitat" className="btn-primary">Back to your Habitat</Link>
      </div>
    </main>
  );
}
